import { render, staticRenderFns } from "./DocumentListItem.vue?vue&type=template&id=358c796d"
import script from "./DocumentListItem.vue?vue&type=script&lang=ts"
export * from "./DocumentListItem.vue?vue&type=script&lang=ts"
import style0 from "./DocumentListItem.vue?vue&type=style&index=0&id=358c796d&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports